// removed by extract-text-webpack-plugin
module.exports = {"Footer":"src-components-Footer----Footer-module---Footer---2UJjc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.module.css
// module id = 374
// module chunks = 114276838955818